import router from "../router/index"
import store from "../store/index"
import ro from "element-ui/src/locale/lang/ro";
import {nav_arr} from '@/utils/nav_list'

let otherlists = nav_arr();
let othermenu = [{id:89,name:'新人自助',path:'/selfservice',plant_type:8}]; //其他的菜单
for (let name in otherlists) {
  otherlists[name].forEach((item) => {
    if (item.has_child == 1 && item.page) {
      item.page.forEach((row) => {
        othermenu.push({
          path: row.route,
          // name: `${item.name}-${row.name}`,
          name: row.name,
          id: row.id,
          type: name,
        });
      });
    } else {
      othermenu.push({
        path: item.route,
        name: item.name,
        id: item.id,
        type: name,
      });
    }
  });
}

export function routesData(data) {
// 重新加载一次 VueRouter
    router.reloadRouter()
    let array = []
    data.forEach(item => {
        if(item.has_child==1){
            item.page.forEach(i => {
            // 组装路由配置
                const temp = {
                    name: i.comp,
                    path: i.route,
                    component: () => import(`../views/${i.comp_addr}.vue`)
                }
                router.addRoute("home", temp)
                array.push(temp)
            })
        }else{
            const temp = {
                name: item.comp,
                path: item.route,
                component: () => import(`../views/${item.comp_addr}.vue`)
            }
            router.addRoute("home", temp)
            // array.push(temp)
        }
    })
    // 动态添加一个 404 页面
    router.addRoute({
        path: "/404",
        component: () => import("../views/404.vue")
    })
}
if(store.state.userpower.length>1){
}
export default {
    inserted(el,bindling){
    	//bindling.value为指令的绑定值
        let perVal = bindling.value;
        if(bindling.value){
        //假设某用户对某模块只有添加和删除的权限
    	//这个权限信息(即pers)应该是不同用户登录时从后台拿到的对应的信息
            let pers=store.state.userbtn;
            //hasPer为true为有权限
    		//hasPer为false为无权限
            let hasPer = pers.some(item=>{
                return item == perVal
            });
             //没有权限就先隐藏此元素吧
            if(!hasPer){
                el.style.display="none"
            }
        }
    }
}


export function setNavTabData(obj,time) {

  let menuobj = store.getters.allmenulist.find(item => obj.path == item.path);
  console.log('动态菜单',store.getters);
  //存在非动态路由
  if(!menuobj){
     menuobj = othermenu.find(item => obj.path == item.path);
     if(!menuobj){
        console.error('没有搜索到的菜单栏',obj);
        return
     }
  }
  if (menuobj) {
    let navtablist = store.state.navtablist;
    let index = navtablist.findIndex((item) => obj.path == item.path);
    if (index == -1) {
      navtablist.push({ ...menuobj,time });
      store.commit('setNavTab', navtablist)
    }else{
      //更新tab栏time 防止不缓存
       navtablist[index].time = time
       store.commit('setNavTab', navtablist)
    }
  }
}
